import styled from '@emotion/styled/macro';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 15px;
  border-radius: 6px;
  font-size: ${14 / 16}rem;
  background-color: var(--brand-primary-10);
  > * {
    margin: 0 !important;
    padding: 0 !important;
  }
`;

export const Title = styled.h2`
  font-family: 'FuturaStd';
  font-weight: bold;
  text-transform: uppercase;
`;
